import React, { useState } from "react";
import { addAssetForWorkshop } from "../../Api/Api";
import { useWorkshop } from "../Common/WorkshopContext";
import { useNotification } from "../Notification/NotificationContext";

const AssetModal = ({ show, handleClose, onAssetAdded }) => {
    const { workshopId } = useWorkshop();
    const { showNotification } = useNotification();

    const [assetType, setAssetType] = useState("");
    const [form, setForm] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = async () => {
        if (!assetType) {
            showNotification("Please select an asset type.", "error");
            return;
        }
        setLoading(true);
        try {
            await addAssetForWorkshop(workshopId, {
                assetType,
                ...form,
            });
            showNotification("Asset added successfully", "success");
            handleClose();
            onAssetAdded();
            setForm({});
            setAssetType("");
        } catch (err) {
            showNotification(err.message || "Error adding asset", "error");
        }
        setLoading(false);
    };

    const renderFields = () => {
        switch (assetType) {
            case "VEHICLE":
                return (
                    <>
                        <Input name="serialNumber" label="Chassis No" value={form.serialNumber} onChange={handleChange} />
                        <Input name="color" label="Color" value={form.color} onChange={handleChange} />
                        <Input name="type" label="Type" value={form.type} onChange={handleChange} />
                    </>
                );
            case "BATTERY":
                return (
                    <>
                        <Input name="serialNumber" label="Serial No" value={form.serialNumber} onChange={handleChange} />
                        <Input name="capacity" label="Capacity" value={form.capacity} onChange={handleChange} />
                        <Input name="type" label="Type" value={form.type} onChange={handleChange} />
                    </>
                );
            case "CHARGER":
                return (
                    <>
                        <Input name="serialNumber" label="Serial No" value={form.serialNumber} onChange={handleChange} />
                        <Input name="capacity" label="Capacity" value={form.capacity} onChange={handleChange} />
                        <Input name="type" label="Type" value={form.type} onChange={handleChange} />
                    </>
                );
            case "MOTOR":
                return (
                    <>
                        <Input name="serialNumber" label="Serial No" value={form.serialNumber} onChange={handleChange} />
                        <Input name="brand" label="Brand" value={form.brand} onChange={handleChange} />
                        <Input name="power" label="Power (kW)" value={form.power} onChange={handleChange} />
                        <Input name="voltage" label="Voltage" value={form.voltage} onChange={handleChange} />
                    </>
                );
            case "CONTROLLER":
                return (
                    <>
                        <Input name="serialNumber" label="Serial No" value={form.serialNumber} onChange={handleChange} />
                        <Input name="wattage" label="Wattage" value={form.wattage} onChange={handleChange} />
                        <Input name="brand" label="Brand" value={form.brand} onChange={handleChange} />
                        <Input name="type" label="Type" value={form.type} onChange={handleChange} />
                    </>
                );
            default:
                return null;
        }
    };


    if (!show) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="bg-white w-full max-w-lg p-6 rounded-lg shadow-lg relative">
                <h2 className="text-xl font-semibold mb-4">Add Asset</h2>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Asset Type</label>
                    <select
                        value={assetType}
                        onChange={(e) => {
                            setAssetType(e.target.value);
                            setForm({});
                        }}
                        className="w-full border border-gray-300 px-3 py-2 rounded-md"
                    >
                        <option value="">Select Type</option>
                        <option value="VEHICLE">Vehicle</option>
                        <option value="BATTERY">Battery</option>
                        <option value="CHARGER">Charger</option>
                        <option value="MOTOR">Motor</option>
                        <option value="CONTROLLER">Controller</option>
                    </select>
                </div>

                {renderFields()}

                <div className="mt-6 flex justify-end space-x-3">
                    <button
                        onClick={handleClose}
                        className="px-4 py-2 rounded-md bg-gray-300 hover:bg-gray-400 text-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="px-4 py-2 rounded-md bg-teal-500 hover:bg-teal-600 text-white"
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
};

const Input = ({ name, label, value, onChange }) => (
    <div className="mb-4">
        <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        <input
            id={name}
            name={name}
            type="text"
            value={value || ""}
            onChange={onChange}
            className="w-full border border-gray-300 px-3 py-2 rounded-md"
        />
    </div>
);

export default AssetModal;
